export default __webpack_public_path__ + "static/media/protiv-logo.f1abe2b0.svg";